import { Component, Input, OnInit } from "@angular/core";

import { ItemHealth } from "src/app/item-health";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-health-right",
	templateUrl: "./health-right.component.html",
	styleUrls: ["./health-right.component.scss"]
})
export class HealthRightComponent implements OnInit {
	@Input()
	item: APIResults.Fleet | APIResults.FleetAsset;

	public itemHealth: ItemHealth;

	ngOnInit() {
		if ((this.item as APIResults.FleetAsset).asset_id !== undefined) {
			this.itemHealth = ItemHealth.FromAsset(this.item as APIResults.FleetAsset);
		} else {
			this.itemHealth = ItemHealth.FromFleet(this.item as APIResults.Fleet);
		}
	}
}
